<template>
  <div class="users">
    <EntityList
      v-bind:endpoint="'api/users'"
      v-bind:filters="'?roles=ROLE_SERVICE_INTEGRATION'"
      v-bind:entity="userEntity"
      v-bind:editAllowedFields="['email', 'password']"
      v-bind:notDisplayedFields="['id', 'password', 'roles']"
      v-bind:addLinkToDetails="false"
      v-bind:defaultValues="{ roles:  this.$store.state.userPermissions.serviceintegration}"
      v-bind:title="'Service Integration Users'"
      v-bind:enableSearch="true"
      v-bind:searchFields="[{ text: 'Email', value: 'email' }]"/>
  </div>
</template>

<script>
import EntityList from './EntityList/EntityList.vue';
import UserEntity from '../store/entity/User';

export default {
  name: 'serviceintegrationusers',
  components: { EntityList },
  data() {
    return {
      userEntity: UserEntity,
    };
  },
};
</script>

<style scoped>

</style>
